// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{padding:20px;height:100%}.wrapper{display:grid;grid-template-columns:2fr 3fr;height:100%}.communication-panel{border-right:1px solid #d8d8d8}.info-panel{padding:10px}.header-summary{display:grid;grid-template-columns:100px 1fr}.attributes{padding:10px;display:grid;grid-template-columns:1fr 1fr;grid-column-gap:20px}.tags{display:inline-flex}", ""]);
// Exports
module.exports = exports;
